const zh = {
  nav: {
    home: '首页',
    category: '分类',
    hanman: '韩漫',
    riman: '日漫',
    guoman: '国漫',
    about: '关于我们',
    search: '搜索漫画...',
  },
  home: {
    heroTitle: '奇妙漫画',
    heroSubtitle: '免费漫画全集在线看，下拉式连续阅读不中断',
    heroDesc: '完结长篇漫画一口气看完，韩漫日漫国漫每日追更，好看的漫画大全尽在奇妙漫画',
    startReading: '开始阅读',
    browseCategory: '浏览分类',
    featuredTitle: '热门推荐',
    featuredDesc: '精心挑选的高分漫画，每一部都值得一读',
    latestTitle: '最新更新',
    latestDesc: '每日更新的最新章节，追更不迷路',
    hotTitle: '人气排行',
    hotDesc: '站内最受欢迎的漫画排行榜',
    categoryTitle: '漫画分类',
    categoryDesc: '按类型快速找到你想看的漫画',
    viewAll: '查看全部',
    rating: '评分',
    views: '阅读',
    chapters: '话',
    statusCompleted: '已完结',
    statusOngoing: '连载中',
    readNow: '立即阅读',
    chapterLatest: '最新',
    updateToday: '今日更新',
  },
  category: {
    title: '漫画分类',
    allCategories: '全部分类',
    resultCount: '共 {{count}} 部漫画',
    noResult: '暂无该分类的漫画',
    sortBy: '排序',
    sortLatest: '最新更新',
    sortPopular: '最受欢迎',
    sortRating: '评分最高',
  },
  comic: {
    author: '作者',
    status: '状态',
    category: '分类',
    totalChapters: '总章节',
    updateDate: '更新时间',
    views: '阅读量',
    rating: '评分',
    description: '作品简介',
    chapterList: '章节列表',
    relatedComics: '相关推荐',
    startReading: '开始阅读',
    continueReading: '继续阅读',
    firstChapter: '第一话',
    latestChapter: '最新话',
  },
  about: {
    title: '关于奇妙漫画',
    brandTitle: '品牌故事',
    brandDesc1: '奇妙漫画成立于2020年，致力于为漫画爱好者提供最优质的免费在线阅读体验。我们的创始团队由一群热爱漫画的年轻人组成，怀着"让每个人都能轻松享受漫画"的初心，打造了这个漫画阅读平台。',
    brandDesc2: '经过多年的发展，奇妙漫画已经积累了超过10万部漫画资源，涵盖韩漫、日漫、国漫等多个品类，日均活跃用户超过百万。我们始终坚持免费阅读的理念，让更多读者能够无障碍地享受漫画的乐趣。',
    brandDesc3: '未来，奇妙漫画将继续深耕漫画阅读领域，不断优化阅读体验，引入更多优质漫画内容，打造中国最受欢迎的漫画阅读平台。',
    featureTitle: '平台特色',
    features: [
      { title: '下拉式连续阅读', desc: '独特的连续阅读模式，一章接一章无缝衔接，无需翻页点击，沉浸式阅读体验', icon: 'ri-file-list-3-line' },
      { title: '海量漫画资源', desc: '超过10万部漫画作品，涵盖韩漫、日漫、国漫，每日更新数百部最新章节', icon: 'ri-database-2-line' },
      { title: '永久免费', desc: '所有漫画完全免费阅读，无需付费，无需订阅，真正实现漫画自由', icon: 'ri-vip-crown-line' },
      { title: '高清画质', desc: '所有漫画均采用高清扫描，画质清晰细腻，完美还原纸质漫画的阅读体验', icon: 'ri-hd-line' },
      { title: '多端同步', desc: '支持电脑、平板、手机多端阅读，阅读进度自动同步，随时随地想看就看', icon: 'ri-device-line' },
      { title: '社区互动', desc: '活跃的漫画社区，与百万漫友一起讨论剧情、分享心得、结交同好', icon: 'ri-chat-smile-2-line' },
    ],
    statsTitle: '平台数据',
    stats: [
      { label: '漫画总量', value: '100,000+' },
      { label: '日活用户', value: '100万+' },
      { label: '累计阅读', value: '50亿+' },
      { label: '日均更新', value: '500+' },
    ],
    testimonialTitle: '用户口碑',
    testimonials: [
      { name: '小明', role: '资深漫友', content: '奇妙漫画真的是我用过最好用的漫画阅读平台！下拉式阅读太方便了，不用一直点翻页，一口气看完一整部漫画的感觉太爽了！' },
      { name: '小丽', role: '韩漫爱好者', content: '韩漫资源特别全，更新也快，画质清晰。每天都在这里追更，已经推荐给身边所有喜欢看漫画的朋友了！' },
      { name: '阿强', role: '日漫粉丝', content: '日漫分类做得很细致，找漫画特别方便。完结漫画专区简直就是宝藏，不用等更新直接一次性看完！' },
      { name: '小花', role: '国漫支持者', content: '国漫的资源越来越多了，而且质量都很高。支持国产漫画，支持奇妙漫画平台！希望越做越好！' },
    ],
    contactTitle: '联系我们',
    contactDesc: '如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们',
    email: '电子邮箱',
    emailValue: 'support@qimiaomanhua.com',
    wechat: '微信公众号',
    wechatValue: '奇妙漫画',
    weibo: '官方微博',
    weiboValue: '@奇妙漫画官方',
    qq: 'QQ群',
    qqValue: '888888888',
    contactForm: '在线留言',
    formName: '姓名',
    formEmail: '邮箱',
    formMessage: '留言内容',
    formSubmit: '提交留言',
    formSuccess: '留言提交成功！我们会尽快回复您。',
    formError: '提交失败，请稍后重试。',
    faqTitle: '常见问题',
    faqs: [
      { q: '奇妙漫画真的免费吗？', a: '是的，奇妙漫画上的所有漫画内容完全免费，无需任何付费即可畅读所有漫画。我们通过广告收入来维持平台运营，不会向用户收取任何费用。' },
      { q: '如何找到我想看的漫画？', a: '您可以通过首页的分类导航按漫画类型浏览，也可以使用搜索功能直接搜索漫画名称。我们还提供热门推荐和最新更新列表，帮助您发现感兴趣的漫画。' },
      { q: '什么是下拉式连续阅读？', a: '下拉式连续阅读是我们独创的阅读模式。您只需向下滚动页面，就可以连续不断地阅读所有章节，无需点击翻页按钮，实现真正的无缝阅读体验。' },
      { q: '支持手机阅读吗？', a: '当然支持！奇妙漫画已针对手机、平板和电脑进行了全面适配。在手机上阅读同样流畅，并且支持竖屏下拉阅读，给您最佳的移动阅读体验。' },
      { q: '漫画多久更新一次？', a: '热门连载漫画通常每周更新1-2话，具体更新频率取决于原作者和汉化组的进度。您可以关注喜欢的漫画，更新时会收到通知提醒。' },
      { q: '如何联系我们？', a: '您可以通过本页面的联系方式与我们取得联系，也可以使用在线留言功能。我们的客服团队会在24小时内回复您的留言。商务合作请发送邮件至 biz@qimiaomanhua.com。' },
    ],
  },
  footer: {
    description: '奇妙漫画 - 免费漫画全集在线看，完结长篇下拉式连续阅读，韩漫日漫国漫免费阅读平台，好看的漫画大全每日追更',
    quickLinks: '快速链接',
    categories: '漫画分类',
    contactInfo: '联系方式',
    copyright: '© 2026 奇妙漫画 版权所有',
    terms: '服务条款',
    privacy: '隐私政策',
    feedback: '意见反馈',
    friends: '友情链接',
  },
  breadcrumb: {
    home: '首页',
    category: '分类',
    about: '关于我们',
  },
  seo: {
    homeTitle: '奇妙漫画 - 免费漫画全集在线看 | 完结长篇下拉式连续阅读 | 好看的漫画大全',
    homeDesc: '奇妙漫画提供免费漫画全集在线阅读，完结长篇漫画一口气看完，下拉式滚动阅读不中断，好看的漫画大全每日追更，韩漫日漫国漫免费阅读平台。',
    categoryTitle: '{{category}}漫画 - 免费{{category}}漫画在线看 | 奇妙漫画',
    categoryDesc: '奇妙漫画为您精选{{category}}漫画，免费在线阅读，下拉式连续阅读不中断，每日更新最新{{category}}漫画章节。',
    aboutTitle: '关于我们 - 奇妙漫画 | 免费漫画阅读平台',
    aboutDesc: '了解奇妙漫画的品牌故事、平台特色和联系方式。我们致力于提供最优质的免费漫画在线阅读体验，超过10万部漫画资源，韩漫日漫国漫全覆盖。',
  },
};

export default zh;